import React from 'react'
import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName,  ColumnNoc,  ColumnWarnings, ColumnExpander, ColumnResult, ColumnQualification as ColumnQualificationGlobal } from "components/common/TableColumns"
import { ColumnPty } from "../common/TableColumns";
import Label from 'components/general/Label';
import SportCode from 'components/common/SportCode';
import { appealIcon, waringIcon } from '../common/Icons';

export function ColumnRoute({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderRoute',
    remove = false,
    route = 'A'
    }) {
    return (
        {
            Header: <><Label data={label} /> {route}</>,
            accessor: (props) => {
                const route_ = props?.extendedResults?.find(er => er?.er_pos === route);
                return route_?.er_sortorder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Route' + route,
            remove: remove,
            Cell: (props) => {
                const res = props.cell.row.original;
                const route_ = res?.extendedResults?.find(er => er?.er_pos === route);
                return (route_?.er_value ? route_.er_value : '') + (route_?.er_rank ? ' (' + route_.er_rank + ')' : '');
            }
        }
    )
}

export function ScoreTime({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-20',
    label = 'HeaderScoreTime',
    remove = false,
    }) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'ScoreTime',
            remove: remove,
            Cell: (props) => {
                const res = props.cell.row.original;
                //console.log(res)
                let time = res?.extendedResults?.find(er => er?.er_code === 'HOLD')?.er_speed;
                let score = res?.resultData;
                return time && score ? `${score} / ${time}` : time ? time : score ? score : '';
            }
        }
    )
}
